import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-element-operate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BorderLine = _resolveComponent("BorderLine")
  const _component_ResizeHandler = _resolveComponent("ResizeHandler")
  const _component_RotateHandler = _resolveComponent("RotateHandler")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.borderLines, (line) => {
      return (_openBlock(), _createBlock(_component_BorderLine, {
        class: "operate-border-line",
        key: line.type,
        type: line.type,
        style: line.style
      }, null, 8, ["type", "style"]))
    }), 128)),
    (!_ctx.elementInfo.lock && (_ctx.isActiveGroupElement || !_ctx.isMultiSelect))
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.textElementResizeHandlers, (point) => {
            return (_openBlock(), _createBlock(_component_ResizeHandler, {
              class: "operate-resize-handler",
              key: point.direction,
              type: point.direction,
              style: point.style,
              onMousedown: _withModifiers($event => _ctx.scaleElement($event, _ctx.elementInfo, point.direction), ["stop"])
            }, null, 8, ["type", "style", "onMousedown"]))
          }), 128)),
          _createVNode(_component_RotateHandler, {
            class: "operate-rotate-handler",
            style: { left: _ctx.scaleWidth / 2 + 'px' },
            onMousedown: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.rotateElement(_ctx.elementInfo)), ["stop"]))
          }, null, 8, ["style"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}